// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Fee = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path stroke="currentColor" strokeLinecap="square" strokeLinejoin="round" d="M5.5 6.497h7M5.5 9.5h7" />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M2.495 3.505v10.702l2.169-1.032 2.168 1.26L9 13.175l2.168 1.26 2.168-1.26 2.169 1.032V3.505z"
    />
  </svg>
);
const ForwardRef = forwardRef(Fee);
export default ForwardRef;
